import { render, staticRenderFns } from "./purchase-order-fee.vue?vue&type=template&id=6a6338e4&scoped=true"
import script from "./purchase-order-fee.vue?vue&type=script&lang=ts"
export * from "./purchase-order-fee.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6338e4",
  null
  
)

export default component.exports